import styled from "@emotion/styled";
import { FormInput } from "@otrium/atoms";
import { Button } from "src/atoms/Button";

const Field = styled.div<{
  $isError?: boolean;
  $isWarning?: boolean;
  $isFocused?: boolean;
}>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  padding-right: ${({ theme }) => theme.space.space4};
  box-sizing: border-box;
  border-radius: 24px;
  background-color: ${({ theme }) => theme.colors.tone.white};
  border: 1px solid
    ${({ theme, $isError, $isWarning, $isFocused }) =>
      $isError
        ? theme.colors.semantic.red
        : $isWarning
        ? theme.colors.semantic.orange
        : $isFocused
        ? theme.colors.semantic.blue
        : "#ddd"};
`;

const StyledInput = styled(FormInput)`
  flex: 1;
  min-width: 0;
  height: 100%;
  border: none;
  background-color: transparent;
  border-radius: 24px;
  padding: 0 ${({ theme }) => theme.space.space8} 0
    ${({ theme }) => theme.space.space16};
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.tone.black};

  &::placeholder {
    color: ${({ theme }) => theme.colors.tone.anthracite};
  }

  &:focus,
  &:focus-visible {
    border: none;
    outline: none;
  }

  &:disabled {
    background-color: transparent;
    color: ${({ theme }) => theme.colors.tone.anthraciteLight};
  }

  &:disabled::placeholder {
    color: ${({ theme }) => theme.colors.tone.silver};
  }
`;

const StyledButton = styled(Button)`
  flex-shrink: 0;
  height: 40px;
  padding-left: ${({ theme }) => theme.space.space24};
  padding-right: ${({ theme }) => theme.space.space24};
`;

export { Field, StyledButton, StyledInput };
